<template>
  <div>
    <v-container v-if="!loadingProduto">
      <v-row dense>
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-text-box-outline
            </v-icon>
            <span class="ml-2">Dados gerais</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row dense class="mt-3">
        <v-col cols="12" sm="6">
          <v-text-field
            outlined
            required
            dense
            hide-details
            maxlength="100"
            class="required rounded-tag-small"
            label="Descrição do produto"
            :error="$v.produto.descricao.$error"
            @blur="$v.produto.descricao.$touch()"
            v-model="produto.descricao"
          />
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            outlined
            required
            dense
            hide-details
            maxlength="50"
            class="required rounded-tag-small"
            label="Código interno"
            :error="$v.produto.codigo.$error"
            @blur="$v.produto.codigo.$touch()"
            v-model="produto.codigo"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <px-select-enum
              dense
              label="Tipo"
              :items="tiposProduto"
              class="rounded-tag-small"
              :error="$v.produto.tipoProduto.$error"
              @blur="$v.produto.tipoProduto.$touch()"
              v-model="produto.tipoProduto"/>
        </v-col>
        <v-col cols="12" sm="1">
          <div class="d-flex align-center">
            <px-anexo v-model="produto.arquivos"
                      :max="3"
                      dot
                      downloadBasePath="files/download-comprador"
                      @loading="onFileLoad(produto, $event)">
                <template v-slot:activator="{ on }">
                  <v-btn icon
                         v-on="on">
                  <v-icon>mdi-paperclip</v-icon>
                </v-btn>
              </template>
            </px-anexo>
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="5">
          <px-autocomplete-grupo
            dense
            class="rounded-tag-small"
            show-details
            label="Categoria"
            v-model="produto.grupoProduto"/>
        </v-col>
        <v-col cols="12" sm="2">
          <px-autocomplete-unidade-medida dense
                                          required
                                          class="required rounded-tag-small"
                                          :error="$v.produto.unidadeMedida.$error"
                                          @blur="$v.produto.unidadeMedida.$touch()"
                                          :only-open="false"
                                          v-model="produto.unidadeMedida"/>
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="2"
            class="rounded-tag-small"
            label="Casas decimais"
            :error="$v.produto.casasDecimais.$error"
            @blur="$v.produto.casasDecimais.$touch()"
            v-model="produto.casasDecimais"
          >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-information-outline</v-icon>
              </template>
              <span>
                Define o número de casas decimais para exibição dos valores(total e quantidade)
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            dense
            outlined
            hide-details
            label="NCM"
            class="rounded-tag-small"
            v-mask="['####.##.##']"
            v-model="produto.ncm"/>
        </v-col>
        <v-col cols="12" sm="1">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Ativo"
                    color="primary"
                    v-model="produto.ativo"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            rows="2"
            dense
            outlined
            hide-details
            auto-grow
            v-model="produto.especificacao"
            label="Especificação"
            class="rounded-tag-small"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-textarea
            dense
            outlined
            hide-details
            rows="2"
            v-model="produto.observacaoInterna"
            label="Observação interna"
            class="rounded-tag-small"/>
        </v-col>
        <v-col cols="12" sm="6">
          <v-textarea
            dense
            outlined
            hide-details
            rows="2"
            v-model="produto.observacaoExterna"
            label="Observação externa"
            class="rounded-tag-small"/>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    color="primary"
                    v-model="produto.isGenerico">
            <template v-slot:label>
              Produto genérico
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon right small v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>
                  Ao ativar essa propriedade, a especificação do produto será exibida
                  no lugar do nome
                </span>
              </v-tooltip>
            </template>
          </v-switch>
        </v-col>
      </v-row>
      <v-row class="mt-2" dense>
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-cash
            </v-icon>
            <span class="ml-2">Financeiro</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row class="mt-2" dense>
        <v-col cols="12" sm="4">
          <px-input-currency
            dense
            label="Preço target"
            class="rounded-tag-small"
            prefix=" "
            :precision="casaDecimal"
            v-model="produto.precoTarget"/>
        </v-col>
        <v-col cols="12" sm="4">
          <px-input-percentual
              dense
              show-suffix
              label="ICMS"
              input-class="rounded-tag-small"
              v-model="produto.icms"/>
        </v-col>
        <v-col cols="12" sm="4">
          <px-input-percentual
              dense
              show-suffix
              label="IPI"
              input-class="rounded-tag-small"
              v-model="produto.ipi"/>
        </v-col>
      </v-row>
      <v-row class="mt-2" dense v-if="hasCamposAdicionais">
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-progress-wrench
            </v-icon>
            <span class="ml-2">Campos adicionais</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row dense v-if="hasCamposAdicionais">
        <v-col cols="12">
          <px-campos-integracao type="produto"
                                dense
                                :form-data="cadastrosAdicionais"
                                ref="produtoCamposIntegracao"/>
        </v-col>
      </v-row>
      <v-row class="mt-2" dense>
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-cart-outline
            </v-icon>
            <span class="ml-2">Finalidade da compra</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-radio-group
            row
            dense
            class="d-flex"
            v-model="produto.finalidadeCompra">
            <v-radio
              v-for="finalidade in finalidades"
              :key="finalidade.key"
              :label="finalidade.description"
              :value="finalidade.key"/>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import validationMixin from '@/mixins/validation-mixin';
import { isEmpty } from 'lodash';
import { required, minValue, maxValue } from 'vuelidate/lib/validators';
import { TipoProduto, FinalidadeCompra } from 'px-business-components';
import { getPrecision } from '@/utils/produto-utils';
import { hasCadastrosAdicionaisProdutoErp } from '@/modules/produtos/campos-erp/helpers/validate-campos-erp';

export default {
  mixins: [validationMixin],
  props: {
    produto: Object,
    loadingProduto: Boolean,
    cadastrosAdicionais: Object,
    erpCamposIntegracao: String,
  },
  data() {
    return {
      tiposProduto: TipoProduto.values,
      finalidades: FinalidadeCompra.values,
    };
  },
  computed: {
    casaDecimal() {
      return getPrecision(this.produto);
    },
    hasCamposAdicionais() {
      return !isEmpty(this.cadastrosAdicionais)
        || hasCadastrosAdicionaisProdutoErp(this.cadastrosAdicionais, this.erpCamposIntegracao);
    },
  },
  methods: {
    onFileLoad(produto, loading) {
      // eslint-disable-next-line no-param-reassign
      produto.$$hasFileLoading = loading;
    },
  },
  created() {
    if (this.produto.tipoProduto === null) {
      this.produto.tipoProduto = TipoProduto.keys.PRODUTO.key;
    }
  },
  validations: {
    produto: {
      descricao: {
        required,
      },
      codigo: {
        required,
      },
      unidadeMedida: {
        required,
      },
      casasDecimais: {
        maxValue: maxValue(10),
        minValue: minValue(2),
      },
      tipoProduto: {
        required,
      },
    },
  },
};
</script>
